import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
import Sidebar from "../components/common/Sidebar";
import styled from "styled-components";
import Header from "../components/common/Header";
import Main from "../components/Main/Main";
import Chat from "../components/common/Chat";
import MobileMenu from "../components/common/MobileMenu";
import LiveScorePage from "../pages/LiveScorePage";
import {
  HashRouter as BrowserRouter,
  Routes,
  Route,
  useLocation,
  Switch,
  Router,
} from "react-router-dom";
import HighlightPage from "../pages/HighlightPage";
import LivePage from "../pages/LivePage";
import HighlightVideo from "../components/highlight/HighlightVideo";
import AssurancePage from "./AssurancePage";
import AssuranceWrite from "../components/assurance/AssuranceWrite";
import SportsBroadcast from "./SportsBroadcast";
import LiveMulti from "../components/concent/LiveMulti";
import LiveMulti2 from "../components/concent/LiveMulti2";

const Wrapper = styled.div`
  display: flex;
  height: fit-content;
  overflow-y: auto;
`;

const MainWrapper = styled.div`
  flex: 1 0;
  overflow: hidden;
  overflow-y: auto;
  height: 100vh;
  @media (max-width: 1100px) {
    overflow-x: hidden;
    height: calc(var(--vh, 1vh) * 100);
  }
`;

const MainPage = ({ setRankingModal, setLogin, setSignup }) => {
  const [openSidebar, setOpenSidebar] = useState(true);
  const [openChat, setOpenChat] = useState(true);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [pathname, setPathname] = useState();
  const [headerPosition, setHeaderPosition] = useState(false);
  const location = useLocation();

  const setScreenSize = () => {
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  useEffect(() => {
    setScreenSize();
    setPathname(window?.location?.pathname);
    console.log(window?.location?.pathname);
    if (window?.location?.pathname === "/highlight/video") {
      setHeaderPosition(true);
    } else {
      setHeaderPosition(false);
    }
  }, [location]);

  const HeaderWrapper = ({ children }) => {
    return (
      <>
        <Sidebar openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
        <MainWrapper openSidebar={openSidebar}>
          <Header
            openSidebar={openSidebar}
            setRankingModal={setRankingModal}
            setLogin={setLogin}
            setSignup={setSignup}
            setOpenChat={setOpenChat}
            openChat={openChat}
            headerPosition={headerPosition}
          />
          {children}
        </MainWrapper>
      </>
    );
  };

  return (
    <Wrapper>
      {mobileMenu ? (
        <HeaderWrapper>
          <MobileMenu
            mobileMenu={mobileMenu}
            setMobileMenu={setMobileMenu}
          ></MobileMenu>
        </HeaderWrapper>
      ) : (
        <Routes>
          <Route
            path="/"
            element={
              <HeaderWrapper>
                <Main setMobileMenu={setMobileMenu} mobileMenu={mobileMenu} />
              </HeaderWrapper>
            }
          />
          <Route
            path="/score"
            element={
              <HeaderWrapper>
                <LiveScorePage
                  setMobileMenu={setMobileMenu}
                  mobileMenu={mobileMenu}
                ></LiveScorePage>
              </HeaderWrapper>
            }
          />
          <Route
            path="/highlight"
            element={
              <HeaderWrapper>
                <HighlightPage
                  setMobileMenu={setMobileMenu}
                  mobileMenu={mobileMenu}
                ></HighlightPage>
              </HeaderWrapper>
            }
          />
          <Route
            path="/highlight/video"
            element={
              <HeaderWrapper>
                <HighlightVideo
                  setMobileMenu={setMobileMenu}
                  mobileMenu={mobileMenu}
                ></HighlightVideo>
              </HeaderWrapper>
            }
          />
          <Route
            path="/assurance"
            element={
              <HeaderWrapper>
                <AssurancePage
                  setMobileMenu={setMobileMenu}
                  mobileMenu={mobileMenu}
                ></AssurancePage>
              </HeaderWrapper>
            }
          />
          <Route
            path="/AssurancePage/write"
            element={
              <HeaderWrapper>
                <AssuranceWrite></AssuranceWrite>
              </HeaderWrapper>
            }
          />
          <Route
            path="/live/*"
            element={
              <HeaderWrapper>
                <LivePage
                  setMobileMenu={setMobileMenu}
                  mobileMenu={mobileMenu}
                  pathname={pathname}
                ></LivePage>
              </HeaderWrapper>
            }
          />
          <Route
            path="/broadcast"
            element={
              <HeaderWrapper>
                <SportsBroadcast
                  setMobileMenu={setMobileMenu}
                  mobileMenu={mobileMenu}
                ></SportsBroadcast>
              </HeaderWrapper>
            }
          />
          <Route
            path="/concent"
            element={
              <LiveMulti
                setMobileMenu={setMobileMenu}
                mobileMenu={mobileMenu}
              ></LiveMulti>
            }
          />
        </Routes>
      )}
      {openChat && <Chat />}
    </Wrapper>
  );
};

export default MainPage;
